// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chat-setting"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M21.499 16.9954C21.499 18.3762 20.3797 19.4954 18.999 19.4954C17.6183 19.4954 16.499 18.3762 16.499 16.9954C16.499 15.6147 17.6183 14.4954 18.999 14.4954C20.3797 14.4954 21.499 15.6147 21.499 16.9954Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21.5 10V3H2.5V20.5L6.5 17H12","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M18.9989 14.4954C17.6182 14.4954 16.4989 15.6147 16.4989 16.9954C16.4989 18.3762 17.6182 19.4954 18.9989 19.4954C20.3796 19.4954 21.4989 18.3762 21.4989 16.9954C21.4989 15.6147 20.3796 14.4954 18.9989 14.4954ZM18.9989 14.4954V13.5M18.9989 20.4954V19.5M16.8319 15.7467L15.9698 15.2489M22.028 18.7467L21.1659 18.2489M21.1659 15.7466L22.028 15.2489M15.9697 18.7466L16.8318 18.2489","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chat-setting')
export default class ChatSettingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-setting',
    }
  }
}
